import React from 'react';

import usePreventBodyScroll from 'hooks/use-prevent-body-scroll';

import { IDrawerProps } from './interfaces';
import { DrawerContainer, MobileOptimizedDrawerContent, StyledCloseButton } from './styled';

const Drawer = ({
  allowsDismiss = true,
  className,
  children,
  onDismiss,
  isVisible,
  disableScroll,
  ...props
}: IDrawerProps) => {
  usePreventBodyScroll();

  return (
    <DrawerContainer isVisible={isVisible} disableScroll={disableScroll}>
      <MobileOptimizedDrawerContent
        className={className}
        role="dialog"
        aria-labelledby="drawer-heading"
        disableScroll={disableScroll}
        {...props}
      >
        {allowsDismiss && <StyledCloseButton onClick={onDismiss} />}
        {children}
      </MobileOptimizedDrawerContent>
    </DrawerContainer>
  );
};

export { Drawer };
